// extracted by mini-css-extract-plugin
module.exports = {"ratingsCompact":"RatingsCompact_ratingsCompact__YxhU_","ratingValue":"RatingsCompact_ratingValue__3QW_q","starRated":"RatingsCompact_starRated__tlmFK"};